import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import SelectField from '../../../components/forms/SelectField';
import { requireUseUntil } from '../../../selectors/admin/models/lineup';
import DatepickerUnlimited from '../../../components/forms/DatepickerUnlimited';
import TextArea from '../../../components/forms/TextArea';
import { dependenciesSelector } from '../../../selectors/admin/forms';
import { CLEARING_OPTIONS } from '../../../constants/settings';

class TemplateClearing extends Component {
    _onInput = (value, field) => {
        const newClearing = { ...this.props.data.clearing, [field]: value };
        this.props.onInput(newClearing, 'clearing');
    };
    render() {
        const data = this.props.data.clearing || {};
        return (
            <div className="ckp-templates-clearing ckp-admin-forms-body">
                <div className="ckp-templates-clearing-title">
                    <h1 className="ckp-ts-h2 u-margin-bottom-2">Default Clearing Values</h1>
                    <h2 className="ckp-ts-h5">
                        These clearing values will be used for media partners in every contract created from this
                        template.
                    </h2>
                </div>
                <div className="ckp-templates-clearing-form">
                    <div className="ckp-admin-grid-row">
                        <SelectField
                            items={CLEARING_OPTIONS}
                            label="Live Clearance"
                            onChange={this._onInput}
                            name="live"
                            value={data.live}
                        />

                        <SelectField
                            items={CLEARING_OPTIONS}
                            label="Non Linear Clearance"
                            onChange={this._onInput}
                            name="nonLinear"
                            value={data.nonLinear}
                        />
                        {requireUseUntil(data.nonLinear) ? (
                            <div className="ckp-admin-grid-column is-1-4">
                                <DatepickerUnlimited
                                    onChange={this._onInput}
                                    value={data.useUntil}
                                    label="Use Until"
                                    name="useUntil"
                                />
                            </div>
                        ) : null}
                    </div>
                    <div className="ckp-admin-grid-row">
                        <TextArea name="comments" value={data.comments} onChange={this._onInput} label="Comments" />
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = state => ({
    dependencies: dependenciesSelector(state)
});

const mapDispatchToProps = dispatch => bindActionCreators({}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(TemplateClearing);



// WEBPACK FOOTER //
// ./src/containers/admin/templates/TemplateClearing.js